import React from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {backToListing} from '../../action/findLocation';


class BackButton extends React.Component{

  constructor(props) {
     super(props);
     this.onClick = this.onClick.bind(this);
   }

   onClick(e){
     e.preventDefault();
     browserHistory.push('/offers');
   }

  render(){

    return (
      <div className="backButton ripple"  onClick={this.onClick}  tabIndex="3">
       <img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/back.svg" />
      </div>
    )
  }
}

   function mapStateToProps(state) {
     return {
       location : state.Location,
       sports : state.SportsFilter
     };
   }

export default connect(mapStateToProps)(BackButton);



// WEBPACK FOOTER //
// ./src/components/Offer-detail-page/backButton.js